import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    latestReleases: []
};

const getters = {};

const actions = {
    getLatestReleases({commit, state}) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getLatestReleases)
                .then(({data}) => {
                    commit(types.SET_LATEST_RELEASES, data.courses.data);
                    state.isProcessing = false;
                    resolve();
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.SET_LATEST_RELEASES](state, courses) {
        state.latestReleases = courses;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};